import cn from 'classnames';

import { CoreServicesListingTabsData } from 'src/types/components';

import AlphaButtons from 'components/BaseHelpers/AlphaButtons';
import Text from 'components/BaseHelpers/Text';

import ServicesList from '../ServicesList';

import styles from './AlphaServiceList.module.scss';

type Service = CoreServicesListingTabsData['fields']['tabs'][number]['services'][number];
export type AlphaServiceListProps = {
  list: Service[];
};

const AlphaServiceList = (props: AlphaServiceListProps): JSX.Element => {
  const sortListIntoAlphaLetterGroups = (list: Service[]) => {
    const groups: Record<string, Service[]> = {};

    // group services by the first letter of their name
    list.forEach((service) => {
      const firstLetter = service.name.charAt(0).toUpperCase();
      if (!groups[firstLetter]) {
        groups[firstLetter] = [];
      }
      groups[firstLetter].push(service);
    });

    // sort groups alphabetically and services within each group alphabetically
    Object.keys(groups).forEach((letter) => {
      groups[letter].sort((a, b) => a.name.localeCompare(b.name));
    });
    return groups;
  };

  const groupedServices = sortListIntoAlphaLetterGroups(props.list);

  const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

  return (
    <div className={styles.main}>
      <div>
        <AlphaButtons
          options={letters.map((letter) => ({
            name: letter,
            label: letter,
            disabled: !groupedServices[letter],
            active: false,
          }))}
          onClick={(option) => {
            const element = document.getElementById(option.name);
            if (element) {
              element.scrollIntoView({ behavior: 'smooth' });
            }
          }}
        />
      </div>
      <div className={styles.lists}>
        {letters.map((letter) => {
          if (!groupedServices[letter]) {
            return null;
          }
          return (
            <div key={letter} className={styles.group} id={letter}>
              <Text tag="h2" className={cn('heading-h2', styles.heading)} field={letter} />
              <ServicesList list={groupedServices[letter] || []} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AlphaServiceList;
